import { ButtonColor, ButtonTypes } from "@/core/@types/types";

export const IndicadoreseButtonColors: Record<keyof ButtonColor, string> = {
  [ButtonTypes.primary]: "#f27220",
  [ButtonTypes.success]: "#dfsa",
  [ButtonTypes.warning]: "#fdsf"
};

export enum EWidgets {
  ExempleChart = 1,
  ExempleCard = 2,
  ExempleCard02 = 3,
  CardConciliacao = 4,
  VendasPanel = 5,
  ExempleAlert = 6,
  AlertAdquirentes = 7,
  CardNotasFiscais = 8,
  CardReceitasVencidas = 9,
  FluxoCaixaPainel = 10,
  DREPanel = 11,
  AnaliseVendasChart = 12,
  Preferencias = 13,
  DesempenhoVendas = 14,
  CardVendasCanceladas = 15,
  CardFechamentoCaixa = 16,
  CardCieloFit = 17,
  TaxasNaDashboard = 18
}

export enum EOriegemDadosFilter {
  contasReceber = "Contas a receber",
  fechamentoCaixa = "Fechamento de caixa"
}

export enum EStatusFilter {
  ambos = "Ambos",
  liquidados = "Liquidados",
  abertos = "Abertos"
}

export enum EDashColors {
  blue = "#0054FF",
  darkBlue = "#345773",
  red = "#FF3033",
  gray = "#C0C0C0",
  lightGray = "#757474",
  lightGreen = "#4a5152",
  lightYellow = "#FFE569",
  lightPurple = "#a276ad",
  white = "#bfc9c4",
  purple = "#6633CC",
  ciano = "#00B1FF",
  green = "#00CC66",
  yellow = "#FFCE00",
  orange = "#FF8B00",
  brown = "#755f5f",
  darkGreen = "#025464",
  darkBlueTwo = "#585d87",
  pink = "#F99B7D",
  neonRed = "#FF6D60",
  neonPink = "#DB005B"
}
